"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MARKETING_CARDS = void 0;

require("./MarketingCarousel.css");

var _react = _interopRequireDefault(require("react"));

var _Carousel = _interopRequireDefault(require("../../gradifui/components/carousel/Carousel"));

var _map = _interopRequireDefault(require("lodash/map"));

var _constants = require("../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MARKETING_CARDS = {
  FINCORE: 0,
  SLP: 1,
  CSU: 2
};
exports.MARKETING_CARDS = MARKETING_CARDS;
var MARKETING_CAROUSEL_SUPERSCRPTS = {
  FinancialCore: function FinancialCore(i) {
    return i;
  },
  PayDown: function PayDown(i) {
    return i + 1;
  },
  SaveUp: function SaveUp(i) {
    return i + 2;
  }
};
var marketingData = [{
  imagePath: require("../assets/redesign2020/marketing-carousel/fincore.png"),
  logoPath: require("../assets/redesign2020/fincore-logo.svg"),
  logoText: "FinancialCore",
  imageAlt: "Financial Core",
  text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "header-line-1"
  }, "You can help Rebecca save up to"), /*#__PURE__*/_react.default.createElement("span", {
    className: "marketing-carousel-highlight"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dollar-sign"
  }, "$"), "9,576"), " in interest off her student loan debt."),
  link: _constants.URLS.MARKETING.REFI
}, {
  imagePath: require("../assets/redesign2020/marketing-carousel/slp.png"),
  logoPath: require("../assets/redesign2020/slp-logo.svg"),
  logoText: "PayDown",
  imageAlt: "Student Loan Paydown",
  text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "header-line-1"
  }, "You can help Alex save up to 2 \xBD years or "), /*#__PURE__*/_react.default.createElement("span", {
    className: "marketing-carousel-highlight"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dollar-sign"
  }, "$"), "17,900"), " off her student loan debt."),
  link: _constants.URLS.MARKETING.PAYDOWN
}, {
  imagePath: require("../assets/redesign2020/marketing-carousel/csu.png"),
  logoPath: require("../assets/redesign2020/csu-logo.svg"),
  logoText: "SaveUp",
  imageAlt: "College SaveUp",
  text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "header-line-1"
  }, "You can help Ethan save up to"), /*#__PURE__*/_react.default.createElement("span", {
    className: "marketing-carousel-highlight"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dollar-sign"
  }, "$"), "15,293"), " in a 529 plan for his daughter's education."),
  link: _constants.URLS.MARKETING.SAVEUP
}];

var _default = function _default(_ref) {
  var defaultProduct = _ref.defaultProduct,
      carouselLegalSuperScript = _ref.carouselLegalSuperScript;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-carousel"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "marketing-carousel-header"
  }, "EXPLORE THE GRADIFI SUITE OF SOLUTIONS"), /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    default: defaultProduct
  }, (0, _map.default)(marketingData, function (_ref2, i) {
    var imagePath = _ref2.imagePath,
        logoPath = _ref2.logoPath,
        imageAlt = _ref2.imageAlt,
        logoText = _ref2.logoText,
        text = _ref2.text,
        link = _ref2.link;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "marketing-carousel-child"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-carousel-image-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-carousel-logo-button animate"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "marketing-carousel-logo",
      alt: imageAlt,
      src: logoPath
    }), logoText), /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-carousel-overlay"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "marketing-carousel-image animate",
      src: imagePath,
      alt: imageAlt
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-carousel-body-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "marketing-carousel-body animate"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "marketing-carousel-bodytext"
    }, text, /*#__PURE__*/_react.default.createElement("sup", null, MARKETING_CAROUSEL_SUPERSCRPTS[logoText](carouselLegalSuperScript))), /*#__PURE__*/_react.default.createElement("a", {
      className: "button",
      tabIndex: "0",
      href: link
    }, "LEARN MORE"))));
  })));
};

exports.default = _default;